
import { AssetMaintenance } from './asset-maintenance.model';
import { ComposedRowsTypeInfo, CrudTypeInfo, RowsEntityDecorator } from '@scisys-uim/uim-common';


export abstract class AssetMaintenanceRowsTypeInfoBase<G> extends ComposedRowsTypeInfo<AssetMaintenance, number, G> {
  constructor(itemTypeInfo: CrudTypeInfo<AssetMaintenance, number>, rowsEntityDecorator: RowsEntityDecorator<AssetMaintenance, number, G>) {
    super(itemTypeInfo, rowsEntityDecorator);
  }
}



